// Curated airport list focused on Schengen-area destinations and the
// top origin markets we see (MENA, India, Pakistan, South-East Asia,
// East Asia, North America, etc.). Each entry: { city, name, iata, country }.
// Kept ~300 entries so the bundled size stays small (<25KB).

export const AIRPORTS = [
  // ---- Schengen Area (all 27 + Iceland/Switzerland/Norway) ----
  { city: "Paris", name: "Charles de Gaulle", iata: "CDG", country: "France" },
  { city: "Paris", name: "Orly", iata: "ORY", country: "France" },
  { city: "Paris", name: "Beauvais", iata: "BVA", country: "France" },
  { city: "Nice", name: "Côte d'Azur", iata: "NCE", country: "France" },
  { city: "Lyon", name: "Saint-Exupéry", iata: "LYS", country: "France" },
  { city: "Marseille", name: "Provence", iata: "MRS", country: "France" },
  { city: "Toulouse", name: "Blagnac", iata: "TLS", country: "France" },
  { city: "Bordeaux", name: "Mérignac", iata: "BOD", country: "France" },
  { city: "Nantes", name: "Atlantique", iata: "NTE", country: "France" },
  { city: "Strasbourg", name: "Entzheim", iata: "SXB", country: "France" },

  { city: "Frankfurt", name: "Frankfurt am Main", iata: "FRA", country: "Germany" },
  { city: "Munich", name: "Franz Josef Strauss", iata: "MUC", country: "Germany" },
  { city: "Berlin", name: "Brandenburg", iata: "BER", country: "Germany" },
  { city: "Hamburg", name: "Hamburg", iata: "HAM", country: "Germany" },
  { city: "Düsseldorf", name: "Düsseldorf", iata: "DUS", country: "Germany" },
  { city: "Cologne", name: "Cologne Bonn", iata: "CGN", country: "Germany" },
  { city: "Stuttgart", name: "Stuttgart", iata: "STR", country: "Germany" },
  { city: "Hanover", name: "Hannover-Langenhagen", iata: "HAJ", country: "Germany" },
  { city: "Nuremberg", name: "Nuremberg", iata: "NUE", country: "Germany" },
  { city: "Leipzig", name: "Leipzig/Halle", iata: "LEJ", country: "Germany" },

  { city: "Rome", name: "Fiumicino", iata: "FCO", country: "Italy" },
  { city: "Rome", name: "Ciampino", iata: "CIA", country: "Italy" },
  { city: "Milan", name: "Malpensa", iata: "MXP", country: "Italy" },
  { city: "Milan", name: "Linate", iata: "LIN", country: "Italy" },
  { city: "Milan", name: "Bergamo Orio al Serio", iata: "BGY", country: "Italy" },
  { city: "Venice", name: "Marco Polo", iata: "VCE", country: "Italy" },
  { city: "Naples", name: "Capodichino", iata: "NAP", country: "Italy" },
  { city: "Florence", name: "Peretola", iata: "FLR", country: "Italy" },
  { city: "Bologna", name: "Guglielmo Marconi", iata: "BLQ", country: "Italy" },
  { city: "Pisa", name: "Galileo Galilei", iata: "PSA", country: "Italy" },
  { city: "Catania", name: "Fontanarossa", iata: "CTA", country: "Italy" },
  { city: "Palermo", name: "Falcone Borsellino", iata: "PMO", country: "Italy" },
  { city: "Turin", name: "Caselle", iata: "TRN", country: "Italy" },

  { city: "Madrid", name: "Barajas", iata: "MAD", country: "Spain" },
  { city: "Barcelona", name: "El Prat", iata: "BCN", country: "Spain" },
  { city: "Palma de Mallorca", name: "Palma", iata: "PMI", country: "Spain" },
  { city: "Malaga", name: "Costa del Sol", iata: "AGP", country: "Spain" },
  { city: "Alicante", name: "Alicante-Elche", iata: "ALC", country: "Spain" },
  { city: "Seville", name: "San Pablo", iata: "SVQ", country: "Spain" },
  { city: "Valencia", name: "Manises", iata: "VLC", country: "Spain" },
  { city: "Bilbao", name: "Bilbao", iata: "BIO", country: "Spain" },
  { city: "Ibiza", name: "Ibiza", iata: "IBZ", country: "Spain" },
  { city: "Tenerife", name: "Tenerife South", iata: "TFS", country: "Spain" },
  { city: "Gran Canaria", name: "Gran Canaria", iata: "LPA", country: "Spain" },

  { city: "Amsterdam", name: "Schiphol", iata: "AMS", country: "Netherlands" },
  { city: "Eindhoven", name: "Eindhoven", iata: "EIN", country: "Netherlands" },
  { city: "Rotterdam", name: "Rotterdam The Hague", iata: "RTM", country: "Netherlands" },

  { city: "Brussels", name: "Brussels", iata: "BRU", country: "Belgium" },
  { city: "Brussels", name: "South Charleroi", iata: "CRL", country: "Belgium" },
  { city: "Antwerp", name: "Deurne", iata: "ANR", country: "Belgium" },
  { city: "Liège", name: "Liège", iata: "LGG", country: "Belgium" },

  { city: "Vienna", name: "Vienna International", iata: "VIE", country: "Austria" },
  { city: "Salzburg", name: "W. A. Mozart", iata: "SZG", country: "Austria" },
  { city: "Innsbruck", name: "Kranebitten", iata: "INN", country: "Austria" },
  { city: "Graz", name: "Graz Thalerhof", iata: "GRZ", country: "Austria" },

  { city: "Lisbon", name: "Humberto Delgado", iata: "LIS", country: "Portugal" },
  { city: "Porto", name: "Francisco Sá Carneiro", iata: "OPO", country: "Portugal" },
  { city: "Faro", name: "Faro", iata: "FAO", country: "Portugal" },
  { city: "Funchal", name: "Madeira", iata: "FNC", country: "Portugal" },

  { city: "Zurich", name: "Zürich", iata: "ZRH", country: "Switzerland" },
  { city: "Geneva", name: "Geneva", iata: "GVA", country: "Switzerland" },
  { city: "Basel", name: "EuroAirport", iata: "BSL", country: "Switzerland" },
  { city: "Bern", name: "Belp", iata: "BRN", country: "Switzerland" },

  { city: "Athens", name: "Eleftherios Venizelos", iata: "ATH", country: "Greece" },
  { city: "Thessaloniki", name: "Macedonia", iata: "SKG", country: "Greece" },
  { city: "Heraklion", name: "Nikos Kazantzakis", iata: "HER", country: "Greece" },
  { city: "Rhodes", name: "Diagoras", iata: "RHO", country: "Greece" },
  { city: "Santorini", name: "Santorini (Thira)", iata: "JTR", country: "Greece" },
  { city: "Mykonos", name: "Mykonos", iata: "JMK", country: "Greece" },
  { city: "Corfu", name: "Ioannis Kapodistrias", iata: "CFU", country: "Greece" },

  { city: "Copenhagen", name: "Kastrup", iata: "CPH", country: "Denmark" },
  { city: "Billund", name: "Billund", iata: "BLL", country: "Denmark" },
  { city: "Aalborg", name: "Aalborg", iata: "AAL", country: "Denmark" },

  { city: "Stockholm", name: "Arlanda", iata: "ARN", country: "Sweden" },
  { city: "Gothenburg", name: "Landvetter", iata: "GOT", country: "Sweden" },
  { city: "Malmö", name: "Malmö", iata: "MMX", country: "Sweden" },

  { city: "Oslo", name: "Gardermoen", iata: "OSL", country: "Norway" },
  { city: "Bergen", name: "Flesland", iata: "BGO", country: "Norway" },
  { city: "Trondheim", name: "Værnes", iata: "TRD", country: "Norway" },
  { city: "Stavanger", name: "Sola", iata: "SVG", country: "Norway" },

  { city: "Helsinki", name: "Vantaa", iata: "HEL", country: "Finland" },
  { city: "Tampere", name: "Pirkkala", iata: "TMP", country: "Finland" },
  { city: "Rovaniemi", name: "Rovaniemi", iata: "RVN", country: "Finland" },

  { city: "Reykjavik", name: "Keflavík", iata: "KEF", country: "Iceland" },

  { city: "Prague", name: "Václav Havel", iata: "PRG", country: "Czech Republic" },
  { city: "Brno", name: "Tuřany", iata: "BRQ", country: "Czech Republic" },

  { city: "Warsaw", name: "Chopin", iata: "WAW", country: "Poland" },
  { city: "Krakow", name: "John Paul II", iata: "KRK", country: "Poland" },
  { city: "Gdańsk", name: "Lech Wałęsa", iata: "GDN", country: "Poland" },
  { city: "Wrocław", name: "Copernicus", iata: "WRO", country: "Poland" },
  { city: "Poznań", name: "Ławica", iata: "POZ", country: "Poland" },
  { city: "Katowice", name: "Pyrzowice", iata: "KTW", country: "Poland" },

  { city: "Budapest", name: "Ferenc Liszt", iata: "BUD", country: "Hungary" },

  { city: "Bratislava", name: "M. R. Štefánik", iata: "BTS", country: "Slovakia" },
  { city: "Košice", name: "Košice", iata: "KSC", country: "Slovakia" },

  { city: "Ljubljana", name: "Jože Pučnik", iata: "LJU", country: "Slovenia" },

  { city: "Zagreb", name: "Franjo Tuđman", iata: "ZAG", country: "Croatia" },
  { city: "Split", name: "Resnik", iata: "SPU", country: "Croatia" },
  { city: "Dubrovnik", name: "Čilipi", iata: "DBV", country: "Croatia" },

  { city: "Tallinn", name: "Lennart Meri", iata: "TLL", country: "Estonia" },
  { city: "Riga", name: "Riga", iata: "RIX", country: "Latvia" },
  { city: "Vilnius", name: "Vilnius", iata: "VNO", country: "Lithuania" },
  { city: "Kaunas", name: "Kaunas", iata: "KUN", country: "Lithuania" },

  { city: "Luxembourg", name: "Findel", iata: "LUX", country: "Luxembourg" },
  { city: "Valletta", name: "Malta International", iata: "MLA", country: "Malta" },
  { city: "Bucharest", name: "Henri Coandă", iata: "OTP", country: "Romania" },
  { city: "Cluj-Napoca", name: "Avram Iancu", iata: "CLJ", country: "Romania" },
  { city: "Sofia", name: "Sofia", iata: "SOF", country: "Bulgaria" },

  // ---- United Kingdom & Ireland ----
  { city: "London", name: "Heathrow", iata: "LHR", country: "United Kingdom" },
  { city: "London", name: "Gatwick", iata: "LGW", country: "United Kingdom" },
  { city: "London", name: "Stansted", iata: "STN", country: "United Kingdom" },
  { city: "London", name: "Luton", iata: "LTN", country: "United Kingdom" },
  { city: "London", name: "City", iata: "LCY", country: "United Kingdom" },
  { city: "Manchester", name: "Manchester", iata: "MAN", country: "United Kingdom" },
  { city: "Edinburgh", name: "Edinburgh", iata: "EDI", country: "United Kingdom" },
  { city: "Glasgow", name: "Glasgow", iata: "GLA", country: "United Kingdom" },
  { city: "Birmingham", name: "Birmingham", iata: "BHX", country: "United Kingdom" },
  { city: "Bristol", name: "Bristol", iata: "BRS", country: "United Kingdom" },
  { city: "Liverpool", name: "John Lennon", iata: "LPL", country: "United Kingdom" },
  { city: "Newcastle", name: "Newcastle", iata: "NCL", country: "United Kingdom" },
  { city: "Belfast", name: "Belfast International", iata: "BFS", country: "United Kingdom" },
  { city: "Dublin", name: "Dublin", iata: "DUB", country: "Ireland" },
  { city: "Cork", name: "Cork", iata: "ORK", country: "Ireland" },
  { city: "Shannon", name: "Shannon", iata: "SNN", country: "Ireland" },

  // ---- GCC / MENA ----
  { city: "Riyadh", name: "King Khalid", iata: "RUH", country: "Saudi Arabia" },
  { city: "Jeddah", name: "King Abdulaziz", iata: "JED", country: "Saudi Arabia" },
  { city: "Dammam", name: "King Fahd", iata: "DMM", country: "Saudi Arabia" },
  { city: "Medina", name: "Prince Mohammad bin Abdulaziz", iata: "MED", country: "Saudi Arabia" },
  { city: "Abha", name: "Abha", iata: "AHB", country: "Saudi Arabia" },
  { city: "Taif", name: "Taif", iata: "TIF", country: "Saudi Arabia" },
  { city: "Tabuk", name: "Tabuk", iata: "TUU", country: "Saudi Arabia" },
  { city: "Yanbu", name: "Yanbu", iata: "YNB", country: "Saudi Arabia" },
  { city: "AlUla", name: "AlUla", iata: "ULH", country: "Saudi Arabia" },
  { city: "NEOM Bay", name: "NEOM Bay", iata: "NUM", country: "Saudi Arabia" },

  { city: "Dubai", name: "Dubai International", iata: "DXB", country: "United Arab Emirates" },
  { city: "Dubai", name: "Al Maktoum", iata: "DWC", country: "United Arab Emirates" },
  { city: "Abu Dhabi", name: "Zayed International", iata: "AUH", country: "United Arab Emirates" },
  { city: "Sharjah", name: "Sharjah", iata: "SHJ", country: "United Arab Emirates" },
  { city: "Ras Al Khaimah", name: "Ras Al Khaimah", iata: "RKT", country: "United Arab Emirates" },

  { city: "Doha", name: "Hamad International", iata: "DOH", country: "Qatar" },
  { city: "Kuwait City", name: "Kuwait International", iata: "KWI", country: "Kuwait" },
  { city: "Manama", name: "Bahrain International", iata: "BAH", country: "Bahrain" },
  { city: "Muscat", name: "Muscat International", iata: "MCT", country: "Oman" },
  { city: "Salalah", name: "Salalah", iata: "SLL", country: "Oman" },

  { city: "Cairo", name: "Cairo International", iata: "CAI", country: "Egypt" },
  { city: "Alexandria", name: "Borg El Arab", iata: "HBE", country: "Egypt" },
  { city: "Sharm El Sheikh", name: "Sharm El Sheikh", iata: "SSH", country: "Egypt" },
  { city: "Hurghada", name: "Hurghada", iata: "HRG", country: "Egypt" },
  { city: "Luxor", name: "Luxor", iata: "LXR", country: "Egypt" },

  { city: "Amman", name: "Queen Alia", iata: "AMM", country: "Jordan" },
  { city: "Beirut", name: "Rafic Hariri", iata: "BEY", country: "Lebanon" },
  { city: "Casablanca", name: "Mohammed V", iata: "CMN", country: "Morocco" },
  { city: "Marrakech", name: "Menara", iata: "RAK", country: "Morocco" },
  { city: "Rabat", name: "Salé", iata: "RBA", country: "Morocco" },
  { city: "Tangier", name: "Ibn Battouta", iata: "TNG", country: "Morocco" },
  { city: "Tunis", name: "Tunis–Carthage", iata: "TUN", country: "Tunisia" },
  { city: "Algiers", name: "Houari Boumediene", iata: "ALG", country: "Algeria" },

  { city: "Istanbul", name: "İstanbul Airport", iata: "IST", country: "Turkey" },
  { city: "Istanbul", name: "Sabiha Gökçen", iata: "SAW", country: "Turkey" },
  { city: "Ankara", name: "Esenboğa", iata: "ESB", country: "Turkey" },
  { city: "Antalya", name: "Antalya", iata: "AYT", country: "Turkey" },
  { city: "Izmir", name: "Adnan Menderes", iata: "ADB", country: "Turkey" },

  { city: "Tehran", name: "Imam Khomeini", iata: "IKA", country: "Iran" },
  { city: "Baghdad", name: "Baghdad International", iata: "BGW", country: "Iraq" },
  { city: "Erbil", name: "Erbil", iata: "EBL", country: "Iraq" },

  // ---- South Asia ----
  { city: "Delhi", name: "Indira Gandhi", iata: "DEL", country: "India" },
  { city: "Mumbai", name: "Chhatrapati Shivaji Maharaj", iata: "BOM", country: "India" },
  { city: "Bengaluru", name: "Kempegowda", iata: "BLR", country: "India" },
  { city: "Chennai", name: "Chennai", iata: "MAA", country: "India" },
  { city: "Hyderabad", name: "Rajiv Gandhi", iata: "HYD", country: "India" },
  { city: "Kolkata", name: "Netaji Subhas Chandra Bose", iata: "CCU", country: "India" },
  { city: "Ahmedabad", name: "Sardar Vallabhbhai Patel", iata: "AMD", country: "India" },
  { city: "Cochin", name: "Cochin", iata: "COK", country: "India" },
  { city: "Trivandrum", name: "Trivandrum International", iata: "TRV", country: "India" },
  { city: "Goa", name: "Dabolim", iata: "GOI", country: "India" },
  { city: "Pune", name: "Pune", iata: "PNQ", country: "India" },
  { city: "Jaipur", name: "Jaipur", iata: "JAI", country: "India" },
  { city: "Lucknow", name: "Chaudhary Charan Singh", iata: "LKO", country: "India" },
  { city: "Calicut", name: "Calicut", iata: "CCJ", country: "India" },
  { city: "Amritsar", name: "Sri Guru Ram Dass Jee", iata: "ATQ", country: "India" },

  { city: "Karachi", name: "Jinnah", iata: "KHI", country: "Pakistan" },
  { city: "Lahore", name: "Allama Iqbal", iata: "LHE", country: "Pakistan" },
  { city: "Islamabad", name: "Islamabad International", iata: "ISB", country: "Pakistan" },
  { city: "Peshawar", name: "Bacha Khan", iata: "PEW", country: "Pakistan" },
  { city: "Multan", name: "Multan", iata: "MUX", country: "Pakistan" },
  { city: "Faisalabad", name: "Faisalabad", iata: "LYP", country: "Pakistan" },
  { city: "Sialkot", name: "Sialkot", iata: "SKT", country: "Pakistan" },

  { city: "Dhaka", name: "Hazrat Shahjalal", iata: "DAC", country: "Bangladesh" },
  { city: "Chittagong", name: "Shah Amanat", iata: "CGP", country: "Bangladesh" },
  { city: "Kathmandu", name: "Tribhuvan", iata: "KTM", country: "Nepal" },
  { city: "Colombo", name: "Bandaranaike", iata: "CMB", country: "Sri Lanka" },
  { city: "Malé", name: "Velana", iata: "MLE", country: "Maldives" },

  // ---- South-East Asia ----
  { city: "Singapore", name: "Changi", iata: "SIN", country: "Singapore" },
  { city: "Kuala Lumpur", name: "Kuala Lumpur International", iata: "KUL", country: "Malaysia" },
  { city: "Bangkok", name: "Suvarnabhumi", iata: "BKK", country: "Thailand" },
  { city: "Bangkok", name: "Don Mueang", iata: "DMK", country: "Thailand" },
  { city: "Phuket", name: "Phuket", iata: "HKT", country: "Thailand" },
  { city: "Chiang Mai", name: "Chiang Mai", iata: "CNX", country: "Thailand" },
  { city: "Jakarta", name: "Soekarno–Hatta", iata: "CGK", country: "Indonesia" },
  { city: "Denpasar", name: "Bali Ngurah Rai", iata: "DPS", country: "Indonesia" },
  { city: "Manila", name: "Ninoy Aquino", iata: "MNL", country: "Philippines" },
  { city: "Cebu", name: "Mactan-Cebu", iata: "CEB", country: "Philippines" },
  { city: "Hanoi", name: "Noi Bai", iata: "HAN", country: "Vietnam" },
  { city: "Ho Chi Minh City", name: "Tan Son Nhat", iata: "SGN", country: "Vietnam" },
  { city: "Phnom Penh", name: "Phnom Penh", iata: "PNH", country: "Cambodia" },
  { city: "Yangon", name: "Yangon", iata: "RGN", country: "Myanmar" },

  // ---- East Asia ----
  { city: "Tokyo", name: "Haneda", iata: "HND", country: "Japan" },
  { city: "Tokyo", name: "Narita", iata: "NRT", country: "Japan" },
  { city: "Osaka", name: "Kansai", iata: "KIX", country: "Japan" },
  { city: "Nagoya", name: "Chubu Centrair", iata: "NGO", country: "Japan" },
  { city: "Fukuoka", name: "Fukuoka", iata: "FUK", country: "Japan" },
  { city: "Sapporo", name: "New Chitose", iata: "CTS", country: "Japan" },
  { city: "Seoul", name: "Incheon", iata: "ICN", country: "South Korea" },
  { city: "Seoul", name: "Gimpo", iata: "GMP", country: "South Korea" },
  { city: "Busan", name: "Gimhae", iata: "PUS", country: "South Korea" },
  { city: "Beijing", name: "Capital", iata: "PEK", country: "China" },
  { city: "Beijing", name: "Daxing", iata: "PKX", country: "China" },
  { city: "Shanghai", name: "Pudong", iata: "PVG", country: "China" },
  { city: "Shanghai", name: "Hongqiao", iata: "SHA", country: "China" },
  { city: "Guangzhou", name: "Baiyun", iata: "CAN", country: "China" },
  { city: "Shenzhen", name: "Bao'an", iata: "SZX", country: "China" },
  { city: "Chengdu", name: "Tianfu", iata: "TFU", country: "China" },
  { city: "Chongqing", name: "Jiangbei", iata: "CKG", country: "China" },
  { city: "Hangzhou", name: "Xiaoshan", iata: "HGH", country: "China" },
  { city: "Xi'an", name: "Xianyang", iata: "XIY", country: "China" },
  { city: "Kunming", name: "Changshui", iata: "KMG", country: "China" },
  { city: "Hong Kong", name: "Hong Kong International", iata: "HKG", country: "Hong Kong" },
  { city: "Macau", name: "Macau", iata: "MFM", country: "Macau" },
  { city: "Taipei", name: "Taoyuan", iata: "TPE", country: "Taiwan" },
  { city: "Ulaanbaatar", name: "Chinggis Khaan", iata: "UBN", country: "Mongolia" },

  // ---- Sub-Saharan Africa (popular hubs) ----
  { city: "Johannesburg", name: "OR Tambo", iata: "JNB", country: "South Africa" },
  { city: "Cape Town", name: "Cape Town", iata: "CPT", country: "South Africa" },
  { city: "Durban", name: "King Shaka", iata: "DUR", country: "South Africa" },
  { city: "Nairobi", name: "Jomo Kenyatta", iata: "NBO", country: "Kenya" },
  { city: "Addis Ababa", name: "Bole", iata: "ADD", country: "Ethiopia" },
  { city: "Lagos", name: "Murtala Muhammed", iata: "LOS", country: "Nigeria" },
  { city: "Abuja", name: "Nnamdi Azikiwe", iata: "ABV", country: "Nigeria" },
  { city: "Accra", name: "Kotoka", iata: "ACC", country: "Ghana" },
  { city: "Dakar", name: "Blaise Diagne", iata: "DSS", country: "Senegal" },
  { city: "Dar es Salaam", name: "Julius Nyerere", iata: "DAR", country: "Tanzania" },
  { city: "Kigali", name: "Kigali", iata: "KGL", country: "Rwanda" },

  // ---- North America ----
  { city: "New York", name: "John F. Kennedy", iata: "JFK", country: "United States" },
  { city: "New York", name: "Newark Liberty", iata: "EWR", country: "United States" },
  { city: "New York", name: "LaGuardia", iata: "LGA", country: "United States" },
  { city: "Los Angeles", name: "Los Angeles International", iata: "LAX", country: "United States" },
  { city: "San Francisco", name: "San Francisco International", iata: "SFO", country: "United States" },
  { city: "Chicago", name: "O'Hare", iata: "ORD", country: "United States" },
  { city: "Chicago", name: "Midway", iata: "MDW", country: "United States" },
  { city: "Miami", name: "Miami International", iata: "MIA", country: "United States" },
  { city: "Washington", name: "Dulles", iata: "IAD", country: "United States" },
  { city: "Washington", name: "Reagan National", iata: "DCA", country: "United States" },
  { city: "Boston", name: "Logan", iata: "BOS", country: "United States" },
  { city: "Dallas", name: "Dallas/Fort Worth", iata: "DFW", country: "United States" },
  { city: "Houston", name: "George Bush", iata: "IAH", country: "United States" },
  { city: "Atlanta", name: "Hartsfield–Jackson", iata: "ATL", country: "United States" },
  { city: "Seattle", name: "Seattle–Tacoma", iata: "SEA", country: "United States" },
  { city: "Denver", name: "Denver", iata: "DEN", country: "United States" },
  { city: "Phoenix", name: "Sky Harbor", iata: "PHX", country: "United States" },
  { city: "Las Vegas", name: "Harry Reid", iata: "LAS", country: "United States" },
  { city: "Orlando", name: "Orlando", iata: "MCO", country: "United States" },
  { city: "Detroit", name: "Detroit Metro", iata: "DTW", country: "United States" },
  { city: "Minneapolis", name: "St Paul", iata: "MSP", country: "United States" },
  { city: "Philadelphia", name: "Philadelphia", iata: "PHL", country: "United States" },
  { city: "San Diego", name: "San Diego", iata: "SAN", country: "United States" },
  { city: "Honolulu", name: "Daniel K. Inouye", iata: "HNL", country: "United States" },

  { city: "Toronto", name: "Pearson", iata: "YYZ", country: "Canada" },
  { city: "Montreal", name: "Pierre Elliott Trudeau", iata: "YUL", country: "Canada" },
  { city: "Vancouver", name: "Vancouver", iata: "YVR", country: "Canada" },
  { city: "Calgary", name: "Calgary", iata: "YYC", country: "Canada" },
  { city: "Ottawa", name: "Macdonald–Cartier", iata: "YOW", country: "Canada" },
  { city: "Edmonton", name: "Edmonton", iata: "YEG", country: "Canada" },

  { city: "Mexico City", name: "Benito Juárez", iata: "MEX", country: "Mexico" },
  { city: "Cancun", name: "Cancun", iata: "CUN", country: "Mexico" },

  // ---- South America ----
  { city: "São Paulo", name: "Guarulhos", iata: "GRU", country: "Brazil" },
  { city: "Rio de Janeiro", name: "Galeão", iata: "GIG", country: "Brazil" },
  { city: "Brasília", name: "Brasília", iata: "BSB", country: "Brazil" },
  { city: "Buenos Aires", name: "Ministro Pistarini", iata: "EZE", country: "Argentina" },
  { city: "Santiago", name: "Arturo Merino Benítez", iata: "SCL", country: "Chile" },
  { city: "Lima", name: "Jorge Chávez", iata: "LIM", country: "Peru" },
  { city: "Bogotá", name: "El Dorado", iata: "BOG", country: "Colombia" },
  { city: "Quito", name: "Mariscal Sucre", iata: "UIO", country: "Ecuador" },

  // ---- Oceania ----
  { city: "Sydney", name: "Kingsford Smith", iata: "SYD", country: "Australia" },
  { city: "Melbourne", name: "Tullamarine", iata: "MEL", country: "Australia" },
  { city: "Brisbane", name: "Brisbane", iata: "BNE", country: "Australia" },
  { city: "Perth", name: "Perth", iata: "PER", country: "Australia" },
  { city: "Adelaide", name: "Adelaide", iata: "ADL", country: "Australia" },
  { city: "Auckland", name: "Auckland", iata: "AKL", country: "New Zealand" },
  { city: "Wellington", name: "Wellington", iata: "WLG", country: "New Zealand" },
  { city: "Christchurch", name: "Christchurch", iata: "CHC", country: "New Zealand" },
];

const STOP_WORDS = ["airport", "international", "intl"];

/** Filter airports by query string. Matches against city / IATA / airport name / country. */
export function searchAirports(query, limit = 8) {
  const q = (query || "").trim().toLowerCase();
  if (q.length < 2) return [];
  const tokens = q.split(/\s+/).filter((t) => !STOP_WORDS.includes(t));
  if (tokens.length === 0) return [];
  const isIata = /^[a-z]{3}$/.test(q);
  const results = [];
  for (const a of AIRPORTS) {
    const haystack = `${a.city} ${a.iata} ${a.name} ${a.country}`.toLowerCase();
    const allMatch = tokens.every((t) => haystack.includes(t));
    if (!allMatch) continue;
    // ranking: exact IATA first, then city startsWith, then everything else
    let score = 0;
    if (isIata && a.iata.toLowerCase() === q) score = 100;
    else if (a.city.toLowerCase().startsWith(q)) score = 50;
    else if (a.iata.toLowerCase().startsWith(q)) score = 40;
    else if (a.city.toLowerCase().includes(q)) score = 20;
    else score = 10;
    results.push({ ...a, _score: score });
    if (results.length >= 200) break;
  }
  return results.sort((a, b) => b._score - a._score).slice(0, limit);
}

export function formatAirport(a) {
  return `${a.city} – ${a.iata}`;
}

/** Parse "City – IATA" (or any string ending in 3-letter IATA) and return the matching airport entry, or null. */
export function findAirportByValue(value) {
  if (!value) return null;
  const m = String(value).toUpperCase().match(/([A-Z]{3})\s*$/);
  if (!m) return null;
  const iata = m[1];
  return AIRPORTS.find((a) => a.iata === iata) || null;
}
